export default "__VITE_ASSET__Dhsk7vDb__"